import React, { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useHistory } from "react-router-dom";
import { FilterPanel } from "./Helper/FilterPanel";

export const TablaGerenteImporteAsesor = ({ datos, boxstate }) => {
  const history = useHistory();

  const categoriasLabel = {
    Tractores: "Tractores",
    Implementos: "Implementos",
    Jardineros: "Jardineros",
    Autoguiados: "Autoguiados",
    Drones: "Drones",
    PA: "P. Aliado",
    TracUsa: "Tractores Se.",
    TriUsa: "Trilladoras Se.",
    Garantia: "Garantía Extendida",
    Poliza: "Poliza Mantenimiento",
  };

  const [filters, setFilters] = useState({
    categorias: "Tractores", // 🔥 solo una categoría
  });

  const filtersConfig = [
    {
      key: "categorias",
      label: "Categorías",
      // icon: "📊",
      options: [
        { value: "Tractores", label: "Tractores", icon: "🚜" },
        { value: "Implementos", label: "Implementos", icon: "🛠️" },
        { value: "Jardineros", label: "Jardineros", icon: "🌱" },
        { value: "Autoguiados", label: "Autoguiados", icon: "🧭" },
        { value: "Drones", label: "Drones", icon: "🚁" },
        { value: "PA", label: "P. Aliado", icon: "🤝" },
        { value: "TracUsa", label: "Tractores Se.", icon: "♻️" },
        { value: "TriUsa", label: "Trilladoras Se.", icon: "🔄" },
        { value: "Garantia", label: "Garantía", icon: "🛡️" },
        { value: "Poliza", label: "Póliza", icon: "📄" },
      ],
    },
  ];

  const categoriaActiva = filters.categorias;

  //Expandible
  const [openSucursales, setOpenSucursales] = useState({});

  // Función para alternar la apertura de la sucursal
  const toggleSucursal = (sucursal) => {
    setOpenSucursales((prev) => ({
      ...prev,
      [sucursal]: !prev[sucursal], // cambia true/false
    }));
  };

  const formatPorcentaje = (real, objetivo) => {
    const r = Number(real) || 0;
    const c = Number(objetivo) || 0;

    if (r === 0 && c === 0) {
      return 0;
    }

    if (c === 0) {
      return 100;
    }

    const porcentaje = ((r / c) * 100).toFixed(2);

    // return Math.min(porcentaje, 100);
    return porcentaje;
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  const formatMiles = (number) =>
    Math.floor(number / 1000).toLocaleString("es-MX");

  // console.log(datos)

  const agrupados = datos.reduce((acc, item) => {
    // 1️⃣ Si el ADR no existe en el acumulador, lo inicializamos
    if (!acc[item.adr]) {
      acc[item.adr] = {
        adr: item.adr,
        totales: {},
        sucursales: {},
      };
    }

    // 2️⃣ Si la sucursal no existe en el ADR, la creamos
    if (!acc[item.adr].sucursales[item.sucursal]) {
      acc[item.adr].sucursales[item.sucursal] = {
        sucursal: item.sucursal,
        totales: {},
        asesores: [],
      };
    }

    // 3️⃣ Agregar el asesor a la sucursal
    acc[item.adr].sucursales[item.sucursal].asesores.push(item);

    // 4️⃣ Sumar los valores de objetivos y reales por categoría en ADR y Sucursal
    [
      "Autoguiados",
      "Drones",
      "Implementos",
      "Jardineros",
      "PA",
      "Tractores",
      "TracUsa",
      "TriUsa",
      "Garantia",
      "Mantenimiento",
    ].forEach((categoria) => {
      // Sumar a nivel ADR
      acc[item.adr].totales[`objetivo_${categoria}`] =
        (acc[item.adr].totales[`objetivo_${categoria}`] || 0) +
        item[`objetivo_${categoria}`];
      acc[item.adr].totales[`real_${categoria}`] =
        (acc[item.adr].totales[`real_${categoria}`] || 0) +
        item[`real_${categoria}`];
      acc[item.adr].totales[`comp_${categoria}`] =
        (acc[item.adr].totales[`comp_${categoria}`] || 0) +
        item[`comp_${categoria}`];

      // Sumar a nivel Sucursal
      acc[item.adr].sucursales[item.sucursal].totales[`objetivo_${categoria}`] =
        (acc[item.adr].sucursales[item.sucursal].totales[
          `objetivo_${categoria}`
        ] || 0) + item[`objetivo_${categoria}`];
      acc[item.adr].sucursales[item.sucursal].totales[`real_${categoria}`] =
        (acc[item.adr].sucursales[item.sucursal].totales[`real_${categoria}`] ||
          0) + item[`real_${categoria}`];
      acc[item.adr].sucursales[item.sucursal].totales[`comp_${categoria}`] =
        (acc[item.adr].sucursales[item.sucursal].totales[`comp_${categoria}`] ||
          0) + item[`comp_${categoria}`];
    });

    return acc;
  }, {});

  const grupoTotales = datos.reduce((acc, item) => {
    [
      "Autoguiados",
      "Drones",
      "Implementos",
      "Jardineros",
      "PA",
      "Tractores",
      "TracUsa",
      "TriUsa",
      "Garantia",
      "Mantenimiento",
    ].forEach((categoria) => {
      acc[`objetivo_${categoria}`] =
        (acc[`objetivo_${categoria}`] || 0) + item[`objetivo_${categoria}`];
      acc[`real_${categoria}`] =
        (acc[`real_${categoria}`] || 0) + item[`real_${categoria}`];
      acc[`comp_${categoria}`] =
        (acc[`comp_${categoria}`] || 0) + item[`comp_${categoria}`];
    });
    return acc;
  }, {});

  const onDetalle = (idasesor, asesor) => {
    const boxstateToSave = {
      ...boxstate,
      pv: {
        ...boxstate.pv,
        sucursal: Array.isArray(boxstate.pv.sucursal) && boxstate.pv.sucursal.length === 1
          ? [{ ...boxstate.pv.sucursal[0], sucursal: capitalizeWords(boxstate.pv.sucursal[0].sucursal) }]
          : [],  // Si hay 0 o más de 1 sucursal, se guarda como vacío
        vendedor: [
          {
            idvendedor: idasesor,
            vendedor: asesor
          }
        ]
      }
    };

    localStorage.setItem('DatosFiltro', JSON.stringify(boxstateToSave));


    history.push({
      pathname: "/Ventas/DashboardScorecardVendedorDetalle",
      state: {
        boxInicial: boxstate,
        idasesor,
        asesor,
      },
    });
  };

  const calcularPorcentaje = (real, comp) => {
    const r = Number(real) || 0;
    const c = Number(comp) || 0;

    if (c === 0) {
      return r === 0 ? 0 : 100;
    }

    const resultado = (r * 100) / c;

    return Number.isFinite(resultado) ? resultado : 0;
  };

  const indicadorPorcentaje = (value) => {

    if (value > 85) {
      return "verde"
    }
    else if (value > 65) {
      return "amarillo"
    }
    else {
      return "rojo"
    }
  };
  // console.log(datosAgrupados)

  return (
    <div className="dash-tabla-score-card-gerente-asesor-table-container-main">
      {/* FILTRO */}
      <div className="dash-tabla-score-card-gerente-asesor-table-filtro-container">
        <FilterPanel
          title=""
          filtersConfig={filtersConfig}
          filters={filters}
          setFilters={setFilters}
        />
      </div>
      <div style={{ flex: 1 }}>
        <div className="dash-tabla-score-card-gerente-asesor-table scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th></th>
                <th></th>

                {/* {filters.categorias.map((categoria) => (
                                    <th key={categoria} colSpan={3}>
                                        <div>{categoriasLabel[categoria]}</div>
                                    </th>
                                ))} */}

                {categoriaActiva && (
                  <th colSpan={boxstate.mostrar_comparativo === "S" ? 7 : 4}>
                    <div>{categoriasLabel[categoriaActiva]}</div>
                  </th>
                )}
              </tr>
              <tr>
                <th colSpan={2}>
                  <div>Asesor</div>
                </th>

                {/* {filters.categorias.map((categoria) => (
                                    <React.Fragment key={categoria}>
                                        <th><div>Objetivo</div></th>
                                        <th><div>Real</div></th>
                                        <th><div>Alcance</div></th>
                                    </React.Fragment>
                                ))} */}

                {categoriaActiva && (
                  <>
                    <th>
                      <div>Objetivo</div>
                    </th>
                    <th>
                      <div>Real</div>
                    </th>
                    <th>
                      <div>Alcance</div>
                    </th>
                    <th></th>

                    {boxstate.mostrar_comparativo === "S" && (
                      <>
                        <th>
                          <div>{boxstate.comparativa}</div>
                        </th>
                        <th>
                          <div>Diferencia</div>
                        </th>
                        <th>
                          <div>Alcance</div>
                        </th>
                      </>
                    )}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {/* FILA GRUPO TOTAL */}
              <tr className="row-grupo-total">
                <td colSpan={2} className="celda-adr asesor-sticky">
                  <strong>GRUPO</strong>
                </td>
                {categoriaActiva && (
                  <>
                    <td>
                      <strong>
                        {FormatMoney(
                          grupoTotales[`objetivo_${categoriaActiva}`],
                          2,
                        )}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {FormatMoney(
                          grupoTotales[`real_${categoriaActiva}`],
                          0,
                        )}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {formatPorcentaje(
                          grupoTotales[`real_${categoriaActiva}`],
                          grupoTotales[`objetivo_${categoriaActiva}`],
                        )}
                        %
                      </strong>
                    </td>
                    <td className="row-indicador">
                      <span
                        className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(grupoTotales[`real_${categoriaActiva}`], grupoTotales[`objetivo_${categoriaActiva}`],))}`}
                      ></span>
                    </td>
                    {boxstate.mostrar_comparativo === "S" && (
                      <>
                        <td>
                          {FormatMoney(
                            grupoTotales[`comp_${categoriaActiva}`],
                            0,
                          )}
                        </td>
                        <td>
                          {FormatMoney(
                            grupoTotales[`real_${categoriaActiva}`] -
                            grupoTotales[`comp_${categoriaActiva}`],
                            0,
                          )}
                        </td>

                        <td>
                          {calcularPorcentaje(
                            grupoTotales[`real_${categoriaActiva}`],
                            grupoTotales[`comp_${categoriaActiva}`],
                          ).toFixed(0)}
                        </td>
                      </>
                    )}
                  </>
                )}
              </tr>

              {Object.values(agrupados).map((adrData) => (
                <React.Fragment key={adrData.adr}>
                  {/*FILA ADR*/}
                  <tr className="row-adr">
                    <td colSpan={2} className="celda-adr asesor-sticky">
                      <strong>{adrData.adr}</strong>
                    </td>
                    {categoriaActiva && (
                      <>
                        <td>
                          <strong>
                            {FormatMoney(
                              adrData.totales[`objetivo_${categoriaActiva}`],
                              0,
                            )}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {FormatMoney(
                              adrData.totales[`real_${categoriaActiva}`],
                              0,
                            )}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {formatPorcentaje(
                              adrData.totales[`real_${categoriaActiva}`],
                              adrData.totales[`objetivo_${categoriaActiva}`],
                            )}
                            %
                          </strong>
                        </td>
                        <td className="row-indicador">
                          <span
                            className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(adrData.totales[`real_${categoriaActiva}`], adrData.totales[`objetivo_${categoriaActiva}`],))}`}
                          ></span>
                        </td>
                        {boxstate.mostrar_comparativo === "S" && (
                          <>
                            <td>
                              {FormatMoney(
                                adrData.totales[`comp_${categoriaActiva}`],
                                0,
                              )}
                            </td>
                            <td>
                              {FormatMoney(
                                adrData.totales[`real_${categoriaActiva}`] -
                                adrData.totales[`comp_${categoriaActiva}`],
                                0,
                              )}
                            </td>
                            <td>
                              {calcularPorcentaje(
                                adrData.totales[`real_${categoriaActiva}`],
                                adrData.totales[`comp_${categoriaActiva}`],
                              ).toFixed(0)}
                            </td>
                          </>
                        )}
                      </>
                    )}
                  </tr>

                  {/*FILAS SUCURSALES*/}
                  {Object.values(adrData.sucursales).map((sucursalData) => (
                    <React.Fragment key={sucursalData.sucursal}>
                      <tr
                        className="row-sucursal"
                        onClick={() => toggleSucursal(sucursalData.sucursal)}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          colSpan={2}
                          className="asesor-sticky"
                          style={{ paddingLeft: "20px" }}
                        >
                          {/* Flecha */}
                          <span
                            style={{ marginRight: "8px", fontSize: "10px" }}
                          >
                            {openSucursales[sucursalData.sucursal] ? "▼" : "▶"}
                          </span>
                          <strong>{sucursalData.sucursal}</strong>
                        </td>
                        {categoriaActiva && (
                          <>
                            <td>
                              {FormatMoney(
                                sucursalData.totales[
                                `objetivo_${categoriaActiva}`
                                ],
                                0,
                              )}
                            </td>
                            <td>
                              {FormatMoney(
                                sucursalData.totales[`real_${categoriaActiva}`],
                                0,
                              )}
                            </td>
                            <td>
                              {formatPorcentaje(
                                sucursalData.totales[`real_${categoriaActiva}`],
                                sucursalData.totales[
                                `objetivo_${categoriaActiva}`
                                ],
                              )}
                              %
                            </td>
                            <td className="row-indicador">
                              <span
                                className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(sucursalData.totales[`real_${categoriaActiva}`], sucursalData.totales[`objetivo_${categoriaActiva}`],))}`}
                              ></span>
                            </td>
                            {boxstate.mostrar_comparativo === "S" && (
                              <>
                                <td>
                                  {FormatMoney(
                                    sucursalData.totales[
                                    `comp_${categoriaActiva}`
                                    ],
                                    0,
                                  )}
                                </td>
                                <td>
                                  {FormatMoney(
                                    sucursalData.totales[
                                    `real_${categoriaActiva}`
                                    ] -
                                    sucursalData.totales[
                                    `comp_${categoriaActiva}`
                                    ],
                                    0,
                                  )}
                                </td>
                                <td>
                                  {calcularPorcentaje(
                                    sucursalData.totales[
                                    `real_${categoriaActiva}`
                                    ],
                                    sucursalData.totales[
                                    `comp_${categoriaActiva}`
                                    ],
                                  ).toFixed(0)}
                                </td>
                              </>
                            )}
                          </>
                        )}
                      </tr>

                      {/*FILAS ASESORES*/}
                      {openSucursales[sucursalData.sucursal] &&
                        sucursalData.asesores.map((asesor) => (
                          <tr
                            key={asesor.asesor}
                            className="row-asesor"
                            onClick={() =>
                              onDetalle(asesor.idasesor, asesor.asesor)
                            }
                          >
                            <td
                              colSpan={2}
                              className="asesor-sticky"
                              style={{ paddingLeft: "40px" }}
                            >
                              {asesor.asesor}
                            </td>
                            {categoriaActiva && (
                              <>
                                <td>
                                  {FormatMoney(
                                    asesor[`objetivo_${categoriaActiva}`],
                                    0,
                                  )}
                                </td>
                                <td>
                                  {FormatMoney(
                                    asesor[`real_${categoriaActiva}`],
                                    0,
                                  )}
                                </td>
                                <td>
                                  {formatPorcentaje(
                                    asesor[`real_${categoriaActiva}`],
                                    asesor[`objetivo_${categoriaActiva}`],
                                  )}
                                  %
                                </td>
                                <td className="row-indicador">
                                  <span
                                    className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(asesor[`real_${categoriaActiva}`], asesor[`objetivo_${categoriaActiva}`],))}`}
                                  ></span>
                                </td>
                                {boxstate.mostrar_comparativo === "S" && (
                                  <>
                                    <td>
                                      {FormatMoney(
                                        asesor[`comp_${categoriaActiva}`],
                                        0,
                                      )}
                                    </td>
                                    <td>
                                      {FormatMoney(
                                        asesor[`real_${categoriaActiva}`] -
                                        asesor[`comp_${categoriaActiva}`],
                                        0,
                                      )}
                                    </td>
                                    <td>
                                      {calcularPorcentaje(
                                        asesor[`real_${categoriaActiva}`],
                                        asesor[`comp_${categoriaActiva}`],
                                      ).toFixed(0)}
                                    </td>
                                  </>
                                )}
                              </>
                            )}
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
